export default __webpack_public_path__ + "static/media/cgpah2.1db1ebc2.svg";